import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, ExternalLink, Link2, Users, FileText, Tag } from "lucide-react";
import { VendorLogo } from "./VendorLogo";
import { VendorStatusBadge } from "./vendorUtils";

export function VendorTile({ vendor, onOpen }) {
  const n = (count, one, many) => `${count} ${count === 1 ? one : many}`;
  const facts = [
    { icon: Tag, text: vendor.category || "Keine Kategorie" },
    { icon: Link2, text: n(vendor.links?.length || 0, "Link", "Links") },
    { icon: Users, text: n(vendor.contacts?.length || 0, "Ansprechpartner", "Ansprechpartner") },
    { icon: FileText, text: n(vendor.document_count || 0, "Dokument", "Dokumente") },
  ];
  return (
    <Card className={`overflow-hidden min-w-0 ${vendor.status === "inactive" ? "opacity-70" : ""}`} data-testid={`software-card-${vendor.id}`}>
      <CardHeader className="pb-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-4 min-w-0 flex-1">
            <VendorLogo vendor={vendor} />
            <div className="min-w-0">
              <CardTitle className="text-xl truncate">{vendor.name}</CardTitle>
              <CardDescription className="line-clamp-2">{vendor.description || "Keine Beschreibung hinterlegt"}</CardDescription>
            </div>
          </div>
          <VendorStatusBadge status={vendor.status} testId={`vendor-status-${vendor.id}`} />
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-2">
          {facts.map((f) => (
            <div key={f.text} className="flex items-center gap-2 text-sm text-muted-foreground min-w-0">
              <f.icon className="w-4 h-4 text-primary shrink-0" />
              <span className="truncate">{f.text}</span>
            </div>
          ))}
        </div>
        {vendor.match_in?.length > 0 && (
          <div className="flex flex-wrap items-center gap-1.5 text-xs" data-testid={`vendor-match-${vendor.id}`}>
            <span className="text-muted-foreground">Treffer in:</span>
            {vendor.match_in.map((m) => <Badge key={m} variant="secondary" className="text-xs">{m}</Badge>)}
          </div>
        )}
        <div className="flex gap-2 pt-2">
          <Button className="flex-1" onClick={onOpen} data-testid={`vendor-open-btn-${vendor.id}`}>
            Profil öffnen
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          {vendor.website && (
            <Button variant="outline" onClick={() => window.open(vendor.website, "_blank", "noopener,noreferrer")} title="Website öffnen" data-testid={`vendor-website-btn-${vendor.id}`}>
              <ExternalLink className="w-4 h-4" />
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
